import { render } from "./CategoryManagerPanel.vue?vue&type=template&id=01777090&scoped=true"
import script from "./CategoryManagerPanel.vue?vue&type=script&lang=js"
export * from "./CategoryManagerPanel.vue?vue&type=script&lang=js"

import "./CategoryManagerPanel.vue?vue&type=style&index=0&id=01777090&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01777090"]])

export default __exports__